import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { FaFileCircleExclamation, FaFileCircleQuestion, FaFilePdf } from "react-icons/fa6";
import { FiAlertCircle } from "react-icons/fi";
import { MdInfo } from "react-icons/md";

import {
  Page,
  Title,
  DivMain,
  Table,
  Theader,
  Th,
  Tbody,
  Trbody,
  Td,
  Buttons,
  Menus,
  ContainerTable,
  TdDisciplina,
  Description,
  DivText,
  Card,
  DivCards,
  Description2,
  Legendas,
  ContainerLoading,
} from "./styles";
import Button from "../../../Components/Button";
import api from "../../../Services/api";
import { Alert } from "../../../utils/Alert";
import CardVerPdfProgressao from "../../../Components/ProgressaoParcial/CardVerPdfProgressao";
import { Url_Pdf } from "../../../assets/URL'S/Url_Pdf";
import Loading from "../../../utils/Loading";
import User from "../../../Services/user";
import CardVerInformacoes from "../../../Components/ProgressaoParcial/CardVerInformacoes";
import CardEnviarProgressao from "../../../Components/ProgressaoParcial/CardEnviarProgressao";
import CardVerPdfEnviado from "../../../Components/ProgressaoParcial/CardVerPdfEnviado";
import { FaFileUpload } from "react-icons/fa";
import { BiSolidSend } from "react-icons/bi";

export const ProgressaoParcialAluno = () => {
  const navigate = useNavigate();
  const [progressoes, setProgressoes] = useState([]);
  const [pdfProgressao, setPdfProgressao] = useState(false);
  const [enviarProgressao, setEnviarProgressao] = useState(false);
  const [pdfEnviado, setPdfEnviado] = useState(false);
  const [progressaoEdit, setProgressaoEdit] = useState(null);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const user = User;

  const isPC = windowSize.width > 1200;

  const listarProgressoes = useCallback(async () => {
    try {
      const res = await api.get("/aluno/listar-progressoes");
      setProgressoes(res.data.flat());
    } catch (err) {
      console.error("Erro ao listar progressões:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    listarProgressoes();
    const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [listarProgressoes]);

  const downloadPdf = async (pdf, fileName) => {
    try {
      const res = await api.get(Url_Pdf(pdf), { responseType: "arraybuffer" });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download_progressao.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar PDF:", error);
      Alert({ tipo: "Erro2", mensagem: "Erro ao baixar o PDF. Por favor, tente novamente." });
    }
  };

  const aceitarProgressao = async (id) => {
    try {
      const result = await Alert({ tipo: "Alert", mensagem: "Deseja aceitar a progressão?" });
      if (result.isConfirmed) {
        const res = await api.put(`aluno/aceitar-progressao?id_progressao=${id}`);
        Alert({ tipo: "Sucesso2", mensagem: res.data.mensagem || "Progressão aceita com sucesso!", tempo: 1200 });
        listarProgressoes();
      }
    } catch (err) {
      console.error("Erro ao aceitar progressão:", err);
      Alert({ tipo: "Erro2", mensagem: err.response?.data?.erro || "Ocorreu um erro ao aceitar a progressão" });
    }
  };

  const handleEnviarProgressao = async (formData) => {
    try {
      console.log(
        "4- Submitting formData:",
        formData.get("file"),
        formData.get("observacao"),
        formData.get("id_progressao")
      );

      const response = await api.put("/aluno/enviar-progressao", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        Alert({
          tipo: "Sucesso2",
          mensagem: response.data.mensagem || "Progressão enviada com sucesso!",
        });
        setEnviarProgressao(false);
        listarProgressoes();
      }
    } catch (error) {
      console.error("Erro ao enviar progressão:", error);
      Alert({
        tipo: "Erro",
        mensagem: error.response?.data?.erro || "Erro ao enviar a progressão. Tente novamente.",
      });
    }
  };

  const renderProgressaoItem = (d, i) => {
    const dataAtual = new Date();
    const dataInicio = new Date(d.data_inicio);
    const dataFim = new Date(d.data_fim);
    const andamento = dataAtual >= dataInicio && dataAtual <= dataFim;
    const terminou = dataAtual > dataFim;
    const emAvaliacao = terminou && d?.conceito == null;
    const turma = d.turma_rh.split(",")[1].split("-").slice(1).join(" - ");
    const curso = d.curso_rh
      .split(",")[1]
      .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
      .trim();
    const disciplina = d.disciplina_rh.split(",")[1];

    const handleProgressaoClick = () => {
      if (terminou || emAvaliacao) return Alert({ tipo: "Alert3", mensagem: "Esta progressão já terminou!" });
      if (!andamento) return Alert({ tipo: "Alert3", mensagem: "Esta progressão ainda não começou!" });
      if (d.aluno_aceitou === null) return aceitarProgressao(d?.id);
      if (d.pdf && andamento) return downloadPdf(d.pdf, `Progressao_${disciplina}.pdf`);
      return Alert({ tipo: "Alert3", mensagem: "Não há PDF disponível" });
    };

    return isPC ? (
      <>
        <Trbody key={i}>
          <Td>
            {emAvaliacao ? (
              <p>
                <span className="emAvaliacao" />
                {d.professor.split(",")[1].toUpperCase()}
              </p>
            ) : terminou ? (
              <p>
                <span className="terminou" />
                {d.professor.split(",")[1].toUpperCase()}
              </p>
            ) : andamento ? (
              <p>
                <span className="andamento" />
                {d.professor.split(",")[1].toUpperCase()}
              </p>
            ) : (
              <p>{d.professor.split(",")[1].toUpperCase()}</p>
            )}
          </Td>
          <Td>{curso}</Td>
          <Td>{turma}</Td>
          <TdDisciplina>{disciplina}</TdDisciplina>
          <Td>{format(dataInicio, "dd/MM/yyyy")}</Td>
          <Td>{format(dataFim, "dd/MM/yyyy")}</Td>
          <Td className="icon">
            <MdInfo
              onClick={() => {
                setShowForm(true);
                setProgressaoEdit(d);
              }}
              size={"1.8rem"}
              cursor={"pointer"}
              title={"informações"}
              color={"#00a2ff"}
            />
          </Td>
          <Td className="icon">
            {d.aluno_aceitou === null ? (
              <FaFileCircleExclamation
                onClick={handleProgressaoClick}
                size={"1.8rem"}
                cursor={"pointer"}
                title={"Aceite para ver pdf"}
                color={"#727272"}
              />
            ) : (
              <FaFilePdf
                onClick={() => {
                  if (!terminou && andamento && d.pdf) {
                    setPdfProgressao(true);
                    setProgressaoEdit(d);
                  } else {
                    handleProgressaoClick();
                  }
                }}
                size={"1.8rem"}
                cursor={"pointer"}
                title={!d.pdf ? "Sem pdf" : "Ver pdf"}
                color={!d.pdf ? "#535353" : "#de000e"}
              />
            )}
          </Td>
          {/*
          <Td className="icon">
            {d.aluno_aceitou === null ? (
              <BiSolidSend
                onClick={handleProgressaoClick}
                size={"1.8rem"}
                cursor={"pointer"}
                title={"Aceite para ver pdf"}
                color={"#727272"}
              />
            ) : (
              <BiSolidSend
                onClick={() => {
                  if (!terminou && andamento && d.pdf) {
                    setEnviarProgressao(true);
                    setProgressaoEdit(d);
                  } else {
                    handleProgressaoClick();
                  }
                }}
                size={"1.8rem"}
                cursor={"pointer"}
                title={!d.pdf ? "Sem pdf" : "Ver pdf"}
                color={!d.pdf ? "#535353" : "#39b700"}
              />
            )}
          </Td> 
          <Td className="icon">
            {d.aluno_aceitou === null ? (
              <FaFileUpload
                onClick={handleProgressaoClick}
                size={"1.8rem"}
                cursor={"pointer"}
                title={"Aceite para ver pdf"}
                color={"#727272"}
              />
            ) : (
              <FaFileUpload
                onClick={() => {
                  if (!terminou && andamento && d.pdf) {
                    setPdfProgressao(true);
                    setProgressaoEdit(d);
                  } else {
                    handleProgressaoClick();
                  }
                }}
                size={"1.8rem"}
                cursor={"pointer"}
                title={!d.pdf ? "Sem pdf" : andamento ? "Enviar progressão" : "Ver progressão enviada"}
                color={!d.pdf ? "#535353" : "#00a2ff"}
              />
            )}
          </Td>
*/}
          <Td $conceito={d?.conceito} className="conceito">
            {d?.conceito || (
              <MdInfo
                onClick={() =>
                  Alert({
                    tipo: "Info",
                    mensagem: `<strong>O resultado será fornecido ${
                      new Date(user?.dt_termino()) < new Date() ? "dentro de 30 dias" : ""
                    } após o término da progressão!</strong>
                    <br/>Caso não tenha recebido, entre em contato com o professor responsável pela disciplina.`,
                  })
                }
                size={"1.8rem"}
                cursor={"pointer"}
                title={"Orientações da Progressão"}
                color={"#ffff"}
                style={{ backgroundColor: "#000000", borderRadius: "100%" }}
              />
            )}
          </Td>
        </Trbody>
      </>
    ) : (
      <Card key={i} $terminou={terminou} $andamento={andamento} $conceito={d?.conceito} onClick={handleProgressaoClick}>
        <span />
        <div className="text">
          <p>Professor:</p> {d.professor.split(",")[1].toUpperCase()}
        </div>
        <div className="text">
          <p>Curso:</p> {curso}{" "}
        </div>
        <div className="text">
          <p>Turma:</p>
          {turma}
        </div>
        <div className="text">
          <p>Disciplina:</p>
          {disciplina}
        </div>
        <div>
          <p>Inicio:</p> {format(dataInicio, "dd/MM/yyyy")}
        </div>
        <div>
          <p>Limite Entrega:</p> {format(dataFim, "dd/MM/yyyy")}
        </div>
        <div className="orientacoes">
          <p>Orientacões</p>
          {d?.orientacoes || "Sem Orientações. Falar com seu professor!"}
        </div>
        <span />
        {d.aluno_aceitou == null && andamento ? (
          <div>
            {" "}
            <p className="pdf">clique para aceitar e ver o PDF</p>{" "}
          </div>
        ) : d?.pdf && andamento && d?.conceito == null && !terminou ? (
          <div>
            {" "}
            <p className="pdf">clique para baixar o pdf</p>{" "}
          </div>
        ) : null}
        {d?.conceito != null && terminou ? (
          <div>
            <p className="conceito">Resultado: {d?.conceito}</p>
          </div>
        ) : null}
      </Card>
    );
  };

  return (
    <Page>
      <DivMain>
        <Menus>
          {isPC ? (
            <>
              <Title>Progressão Parcial</Title>
              <Buttons>
                <Button
                  event={() => navigate("/aluno")}
                  width="8rem"
                  margintop="1%"
                  placeholder="Voltar"
                  backgroundcolor="#1a2e35"
                  borderRadius="30px 30px 0px 0px"
                />
              </Buttons>
              {loading ? null : (
                <>
                  {progressoes.length > 0 && (
                    <>
                      <Description2>
                        <p>
                          Clique no icone:{" "}
                          <FaFileCircleExclamation title={"Aceite para ver pdf"} size={"1.1rem"} color={"#ffffff"} />
                        </p>
                        <p>Para aceitar e ver o PDF</p>
                      </Description2>
                      <Description>
                        <p>
                          <span className="andamento" />
                          Em Andamento
                        </p>
                        <p>
                          <span className="emAvaliacao" />
                          Em avaliação
                        </p>
                        <p>
                          <span className="terminou" />
                          Encerradas
                        </p>
                      </Description>
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <Buttons>
                <Button
                  event={() => navigate("/aluno")}
                  width="8rem"
                  margintop="0%"
                  placeholder="Voltar"
                  backgroundcolor="#1a2e35"
                  borderRadius="30px 30px 0px 0px"
                />
              </Buttons>
              <Legendas>
                <Title>Progressão Parcial</Title>
                {loading ? null : (
                  <>
                    {progressoes.length > 0 && (
                      <Description>
                        <p>
                          <span />
                          Não iniciada
                        </p>
                        <p>
                          <span className="andamento" />
                          Em Andamento
                        </p>
                        <p>
                          <span className="terminou" />
                          Encerradas
                        </p>
                      </Description>
                    )}
                  </>
                )}
              </Legendas>
            </>
          )}
        </Menus>
        {loading ? (
          <ContainerLoading>
            <Loading />
          </ContainerLoading>
        ) : (
          <ContainerTable>
            {isPC ? (
              progressoes.length > 0 ? (
                <Table>
                  <Theader>
                    <tr>
                      <Th>Professor</Th>
                      <Th>Curso</Th>
                      <Th style={{ width: "20%" }}>Turma</Th>
                      <Th>Disciplina</Th>
                      <Th>Início</Th>
                      <Th>Limite Entrega</Th>
                      {/* <Th>Orientacões</Th> */}
                      <Th>Informações</Th>
                      <Th>
                        PDF <p>Progressão</p>
                      </Th>
                      {/*
                      <Th>Enviar</Th>
                      <Th>
                        PDF <p>Enviado</p>
                      </Th>
                      */}
                      <Th>Resultado</Th>
                    </tr>
                  </Theader>
                  <Tbody>{progressoes.map(renderProgressaoItem)}</Tbody>
                </Table>
              ) : (
                <>
                  <Table>
                    <Theader>
                      <tr>
                        <Th>Professor</Th>
                        <Th>Curso</Th>
                        <Th style={{ width: "20%" }}>Turma</Th>
                        <Th>Disciplina</Th>
                        <Th>Início</Th>
                        <Th>Limite Entrega</Th>
                        {/* <Th>Orientacões</Th> */}
                        <Th>Informações</Th>
                        <Th>
                          PDF <p>Progressão</p>
                        </Th>
                        {/*
                        <Th>Enviar</Th>
                        <Th>PDF Enviado</Th>
                        */}
                        <Th>Resultado</Th>
                      </tr>
                    </Theader>
                  </Table>
                  <DivText></DivText>
                </>
              )
            ) : progressoes.length > 0 ? (
              <DivCards>{progressoes.map(renderProgressaoItem)}</DivCards>
            ) : (
              <DivText>Você não está em Progressão</DivText>
            )}
          </ContainerTable>
        )}
      </DivMain>
      <CardVerPdfProgressao Show={pdfProgressao} setShow={setPdfProgressao} progressaoEdit={progressaoEdit} />
      <CardEnviarProgressao
        Show={enviarProgressao}
        setShow={setEnviarProgressao}
        progressaoEdit={progressaoEdit}
        onSubmit={handleEnviarProgressao}
      />
      <CardVerPdfEnviado Show={pdfEnviado} setShow={setPdfEnviado} progressaoEdit={progressaoEdit} />
      <CardVerInformacoes show={showForm} setShow={setShowForm} progressaoEdit={progressaoEdit} />
    </Page>
  );
};
